// The percent figure of the casino (casino.md §9).
//
// One small module, because the lobby, the club head, the table help and
// the hold'em head all state a share, and each must state it one way.

import { LOCALE } from '../../gen/strings';
import { groupThousands } from '../../locale/group';

/**
 * The decimal mark of the effective language (`i18n.md` §2).
 *
 * It is built one time, at load, because the language is picked ONCE and
 * a render pass must pay nothing for the second language
 * (`client/CLAUDE.md`). Grouping is off here: the thousands mark of every
 * figure the client prints is the thin space of `locale/group.ts` (R687),
 * and `groupThousands` writes it.
 */
const DECIMAL = new Intl.NumberFormat(LOCALE, {
  maximumFractionDigits: 1, useGrouping: false,
});

/**
 * A percentage, with one decimal and no trailing zero. 2.7 stays 2.7 and
 * 5.0 reads 5, because the house does not state a decimal it does not have.
 *
 * The decimal mark is the language's own, so a German reader reads
 * "2,7 %" and an English reader "2.7%" (R988). The digits before the mark
 * still take the thin space of every other figure, so one house line and
 * one credit figure read alike.
 */
export function pct(v: number): string {
  const n = Math.round((Number.isFinite(v) ? v : 0) * 10) / 10;
  const text = DECIMAL.format(n);
  // Everything from the first character that is neither a digit nor a
  // minus is the decimal mark and the decimal itself. The head is a whole
  // number, so `groupThousands` groups it the one way the client groups.
  const cut = text.search(/[^\d-]/);
  if (cut < 0) return groupThousands(n);
  return groupThousands(Number(text.slice(0, cut))) + text.slice(cut);
}
